module.exports = __webpack_public_path__ + "img/56.maintenance_problem.5426e159.svg";